/* eslint-disable */
import Vue from 'vue'

export default ({ app, store }, inject) => {
  inject('initMindboxMetric', function(mindboxId) {
    const pluginName = 'mindboxMetric_' + mindboxId
    if (!Vue[pluginName]) {
      Vue[pluginName] = true
      if (
        process.env.NODE_ENV !== 'production' ||
        mindboxId === null ||
        mindboxId === undefined
      )
        return
      // metric code
      !(function () {
        const t = document.createElement('script')
        ;(t.type = 'text/javascript'),
          (t.async = !0),
          (t.src = 'https://api.mindbox.ru/scripts/v1/tracker.js'),
          (t.onload = function () {
            const mindbox =
              window.mindbox ||
              function () {
                mindbox.queue.push(arguments);
              };
            mindbox.queue = mindbox.queue || [];
            mindbox('create', { endpointId: mindboxId });

            mindbox('async', {
              operation: 'VisitedSite',
              data: {
                viewProduct: {
                  product: {
                    ids: {
                      sites: window.location.origin + window.location.pathname,
                    },
                  },
                },
                referrerUrl: document.referrer,
              },
              onError: function (error) {
                console.error(`Error while sending landing data to mindbox: ${error}`);
              },
            });
          })
          document.head.appendChild(t)
      })()
      app.router.afterEach((to, from) => {

      })
    }
  })
}
